<script setup lang="ts">
type TProps = {
  name: string;
  url?: string;
};

const props = defineProps<TProps>();

const isLink = computed(() => {
  return Boolean(props.url && props.url.length > 0);
});
</script>

<template>
  <component
    :is="isLink ? 'a' : 'div'"
    :target="isLink ? '_blank' : null"
    :href="url"
    class="bg-odd-transparent text-2xs/4 md:text-sm/5 font-secondary w-fit py-0.5 px-2 whitespace-nowrap rounded-sm"
    :class="{ 'hover:underline': isLink }"
  >
    {{ name }}
  </component>
</template>
